import { DEFAULT_INDICATOR_WIDGET_PROPS_BY_NAME } from '@/pages/shared/hooks/useDefaultWidgetProps';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const useIndicatorCardConfiguration = (name: string): any => {
  if (!(name in DEFAULT_INDICATOR_WIDGET_PROPS_BY_NAME)) {
    return undefined;
  }

  const getterWidgetProps =
    DEFAULT_INDICATOR_WIDGET_PROPS_BY_NAME[`${name}` as keyof typeof DEFAULT_INDICATOR_WIDGET_PROPS_BY_NAME];
  return getterWidgetProps();
};
